export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 1000];
export const DEFAULT_PAGE_SIZE = 10;
